import { render, staticRenderFns } from "./CreateTing.vue?vue&type=template&id=3487a202"
import script from "./CreateTing.vue?vue&type=script&lang=js"
export * from "./CreateTing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports